import { supabase, toError } from './supabase';

type CreateBillingPortalSessionResponse = {
    url?: string;
    error?: string;
};

export async function createBillingPortalSession(): Promise<string> {
    const { data, error } = await supabase.functions.invoke<CreateBillingPortalSessionResponse>(
        'create-billing-portal-session',
        {
            method: 'POST',
            body: {},
        },
    );

    if (error) {
        throw toError(error);
    }

    if (!data?.url) {
        throw new Error(data?.error || 'Billing portal session was not created');
    }

    return data.url;
}
